import { BadRequestError } from '@cian/valuation-utils-component';
import {
  fetchGetHouseInfoWeb,
  TGetHouseInfoWebResponse,
} from '../../repositories/price-estimator/v2/get-house-info-web';
import { TThunkAction } from '../../types/redux';
import { getHouseInfoRequest, getHouseInfoSuccess, getHouseInfoFailure } from './actions';

export const getHouseInfo = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const state = getState();
  const { houseId } = state.filters;

  dispatch(getHouseInfoRequest());

  try {
    const res: TGetHouseInfoWebResponse = await fetchGetHouseInfoWeb({
      httpApi: context.httpApi,
      parameters: { realtyId: houseId as number },
    });

    if (res.statusCode !== 200) {
      throw new BadRequestError({
        domain: 'getHouseInfo.ts',
        message: res.response.message as string,
        details: { errors: JSON.stringify(res.response.errors) },
      });
    }

    dispatch(getHouseInfoSuccess(res.response));
  } catch (e) {
    if (e instanceof BadRequestError) {
      context.logger.debug('getHouseInfo.ts: bad request', { message: e.message, domain: e.domain });
    } else {
      context.logger.error(e);
    }

    dispatch(getHouseInfoFailure());
  }
};
